/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';

import IconSelectInputComponent from './advisory-flow-inputs/icon-select/IconSelectInputComponent';
import MultiSelectSimpleInputComponent from './advisory-flow-inputs/multiselect-simple/MultiselectSimpleInputComponent';
import AccidentsInputPicker from './advisory-flow-inputs/accident/AccidentsInputPicker';
import AddressInputPicker from './advisory-flow-inputs/address/AddressInputPicker';
import AmountInputPicker from './advisory-flow-inputs/amount/AmountInputPicker';
import AnnexesInputPicker from './advisory-flow-inputs/annexes/AnnexesInputPicker';
import CarInputPicker from './advisory-flow-inputs/car/CarInputPicker';
import CompanyRegistrationInputPicker from './advisory-flow-inputs/company-search/CompanyRegistrationInputPicker';
import CheckboxInputPicker from './advisory-flow-inputs/checkbox/CheckboxInputPicker';
import CurrencyInputPicker from './advisory-flow-inputs/currency/CurrencyInputPicker';
import DateInputPicker from './advisory-flow-inputs/date/DateInputPicker';
import HomeInputPicker from './advisory-flow-inputs/home/HomeInputPicker';
import KilometerSliderInputPicker from './advisory-flow-inputs/slider/KilometerSliderInputPicker';
import LinkInputPicker from './advisory-flow-inputs/link/LinkInputPicker';
import MaskedInputPicker from './advisory-flow-inputs/masked/MaskedInputPicker';
import PercentageInputPicker from './advisory-flow-inputs/percentage/PercentageInputPicker';
import RadioInputPicker from './advisory-flow-inputs/radio/RadioInputPicker';
import SecuritySystemInputPicker from './advisory-flow-inputs/security-system/SecuritySystemInputPicker';
import SelectInputPicker from './advisory-flow-inputs/select/SelectInputPicker';
import SingleCheckboxInputPicker from './advisory-flow-inputs/single-checkbox/SingleCheckboxInputPicker';
import TelephoneNumberInputPicker from './advisory-flow-inputs/telephone-number/TelephoneNumberInputPicker';
import TextInputPicker from './advisory-flow-inputs/input/TextInputPicker';

import { FlowsQuestion } from '../../types/FlowsTypes';
import { Inputs } from '../../types/Enums';
import UnitInputComponent from './company-scan-inputs/unit/UnitInputComponent';
import LinksInputComponent from './company-scan-inputs/links/LinksInputComponent';
import MultiLineInputComponent from './company-scan-inputs/multiline/MultiLineInputComponent';
import PiaClaimsInputComponent from './advisory-flow-inputs/pia-claims/PiaClaimsInputComponent';
import TableInputComponent from './company-scan-inputs/table/components/TableInputComponent';
import NaceCodeInputComponent from './company-scan-inputs/nace-input/NaceCodeInputComponent';
import IndexSelectInputComponent from './company-scan-inputs/index/index-select/IndexSelectInputComponent';
import IndexMultiselectInputComponent from './company-scan-inputs/index/index-multiselect/IndexMultiselectInputComponent';
import MultiselectDetailedPicker from './advisory-flow-inputs/multiselect/MultiselectDetailedPicker';
import SelectDetailedPicker from './advisory-flow-inputs/select-detailed/SelectDetailedPicker';
import MultiSelectPicker from './advisory-flow-inputs/multiselect/MultiselectPicker';
import AdvisoryNumberPlateInputComponent from '@flows/src/components/input/company-scan-inputs/number-plate/AdvisoryNumberPlateInputComponent';
import HiddenInputComponent from '@flows/src/components/input/advisory-flow-inputs/hidden/HiddenInputComponent';
import RadioSmallInputPicker from './advisory-flow-inputs/radio/RadioSmallInputPicker';
import FixedCoveragesInputComponent from './advisory-flow-inputs/fixed-coverages/FixedCoveragesInputComponent';
import DisplayInputComponent from './advisory-flow-inputs/display/DisplayInputComponent';

interface InputProps {
  question: FlowsQuestion;
}

/**
 * TODO: Pickers should be removed and should only be used in case that the
 * input component is dependant on a variable other than the flow id
 */
const advisoryFlowInputComponents = {
  [Inputs.INPUT]: (props: InputProps) => <TextInputPicker {...props} />,
  [Inputs.SELECT]: (props: InputProps) => <SelectInputPicker {...props} />,
  [Inputs.DATE]: (props: InputProps) => <DateInputPicker {...props} />,
  [Inputs.CHECKBOX]: (props: InputProps) => <CheckboxInputPicker {...props} />,
  [Inputs.SINGLE_CHECKBOX]: (props: InputProps) => (
    <SingleCheckboxInputPicker {...props} />
  ),
  [Inputs.ADDRESS]: (props: InputProps) => <AddressInputPicker {...props} />,
  [Inputs.TELEPHONE_NUMBER]: (props: InputProps) => (
    <TelephoneNumberInputPicker {...props} />
  ),
  [Inputs.CAR]: (props: InputProps) => <CarInputPicker {...props} />,
  [Inputs.ACCIDENT]: (props: InputProps) => <AccidentsInputPicker {...props} />,
  [Inputs.HOME]: (props: InputProps) => <HomeInputPicker {...props} />,
  [Inputs.PERCENTAGE]: (props: InputProps) => (
    <PercentageInputPicker {...props} />
  ),
  [Inputs.CURRENCY]: (props: InputProps) => <CurrencyInputPicker {...props} />,
  [Inputs.ANNEXES]: (props: InputProps) => <AnnexesInputPicker {...props} />,
  [Inputs.ROOM]: (props: InputProps) => <AmountInputPicker {...props} />,
  [Inputs.SECURITY_SYSTEM]: (props: InputProps) => (
    <SecuritySystemInputPicker {...props} />
  ),
  [Inputs.MULTISELECT]: (props: InputProps) => <MultiSelectPicker {...props} />,
  [Inputs.MULTISELECT_DETAILED]: (props: InputProps) => (
    <MultiselectDetailedPicker {...props} />
  ),
  [Inputs.MULTISELECT_SIMPLE]: (props: InputProps) => (
    <MultiSelectSimpleInputComponent {...props} />
  ),
  [Inputs.SLIDER]: (props: InputProps) => (
    <KilometerSliderInputPicker {...props} />
  ),
  [Inputs.ICON_SELECT]: (props: InputProps) => (
    <IconSelectInputComponent {...props} />
  ),
  [Inputs.SELECT_DETAILED]: (props: InputProps) => (
    <SelectDetailedPicker {...props} />
  ),
  [Inputs.LINK]: (props: InputProps) => <LinkInputPicker {...props} />,
  [Inputs.LINKS]: (props: InputProps) => <LinksInputComponent {...props} />,
  [Inputs.MULTILINE]: (props: InputProps) => (
    <MultiLineInputComponent {...props} />
  ),
  [Inputs.MASKED]: (props: InputProps) => <MaskedInputPicker {...props} />,
  [Inputs.COMPANY_SEARCH]: (props: InputProps) => (
    <CompanyRegistrationInputPicker {...props} />
  ),
  [Inputs.RADIO]: (props: InputProps) => <RadioInputPicker {...props} />,
  [Inputs.RADIO_SMALL]: (props: InputProps) => (
    <RadioSmallInputPicker {...props} />
  ),
  [Inputs.AMOUNT]: (props: InputProps) => <AmountInputPicker {...props} />,
  [Inputs.UNIT]: (props: InputProps) => <UnitInputComponent {...props} />,
  [Inputs.PIA_CLAIMS]: (props: InputProps) => (
    <PiaClaimsInputComponent {...props} />
  ),
  [Inputs.NACE_CODE]: (props: InputProps) => (
    <NaceCodeInputComponent {...props} />
  ),
  [Inputs.TABLE]: (props: InputProps) => <TableInputComponent {...props} />,
  [Inputs.HIDDEN]: (props: InputProps) => <HiddenInputComponent {...props} />,
  [Inputs.INDEX_SELECT]: (props: InputProps) => (
    <IndexSelectInputComponent {...props} />
  ),
  [Inputs.INDEX_MULTISELECT]: (props: InputProps) => (
    <IndexMultiselectInputComponent {...props} />
  ),
  [Inputs.NUMBER_PLATE]: (props: InputProps) => (
    <AdvisoryNumberPlateInputComponent {...props} />
  ),
  [Inputs.COVERAGE]: (props: InputProps) => (
    <FixedCoveragesInputComponent {...props} />
  ),
  [Inputs.DISPLAY]: (props: InputProps) => <DisplayInputComponent {...props} />,
};

export default advisoryFlowInputComponents;
